import React from 'react'
import { PhotoIcon } from '@heroicons/react/24/outline'

export default function ImagePlaceholder({ caption, className = '' }) {

  return (
    <div className={`flex flex-col items-center justify-center gap-2 bg-gray-100 p-6 text-center ${className}`}>
      <PhotoIcon className="h-8 w-8 text-gray-400" aria-hidden="true" />
      {caption && <p className="text-xs text-gray-500">{caption}</p>}
    </div>
  )
}
